import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ConfigureScreensModalComponent } from '../configure-screens-modal/configure-screens-modal.component';
import { SelectScreensModalComponent } from '../select-screens-modal/select-screens-modal.component';
import { SelectStatesModalComponent } from '../select-states-modal/select-states-modal.component';
import { PolicyXML, State, Operation, Feature, Screen } from 'src/app/models/common'
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { LoaderService } from 'src/app/services/loader.service';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VersionHistoryComponent } from '../version-history/version-history.component';

@Component({
  selector: 'app-configure-policy-modal',
  templateUrl: './configure-policy-modal.component.html',
  styleUrls: ['./configure-policy-modal.component.scss']
})
export class ConfigurePolicyModalComponent implements OnInit,IDeactivateComponent {
  IsDirty=false;
  policyid: string;
  policy: PolicyXML;
  module: string;
  states: State[];
  screens: Screen[] = [];
  selectedStates: any[];
  selectedScreens: any[];
  rejectOp: boolean;
  onholdOp: boolean;
  discardedOp: boolean;
  withdrawOp: boolean;
  allOperations: Operation[];
  action: Subject<any> = new Subject();
  screencode: any;
  configurePolicyForm = new UntypedFormGroup({
    manageStateDraft: new UntypedFormControl(true),
    manageStateSubmitted: new UntypedFormControl(true),
    manageStateClosed: new UntypedFormControl(true),
    rejectOperation: new UntypedFormControl(true),
    onholdOperation: new UntypedFormControl(true),
    discardedOperation: new UntypedFormControl(true),
    withdrawOperation: new UntypedFormControl(true)
  });

  constructor(
    private modalService: NgbModal,
    private summaryService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    public route: ActivatedRoute,
    public commonService:CommonService,
    public loaderService:LoaderService
  ) {

    this.screencode = route.snapshot.params['code'];
  }

  ngOnInit() {

    this.rejectOp = false;
    this.onholdOp = false;
    this.discardedOp = false;
    this.withdrawOp = false;
    // Call Get States
    this.getStates();
    //debugger;
    // Assigning all operations
    //this.allOperations = [];
    //this.allOperations.push({ Name: "Submit", Code: "o1", Type: "", ISCHECKED: false, IsDeleted: false });
    //this.allOperations.push({ Name: "Route", Code: "o2", Type: "", ISCHECKED: false, IsDeleted: false });
    //this.allOperations.push({ Name: "Return", Code: "o3", Type: "", ISCHECKED: false, IsDeleted: false });
    //this.allOperations.push({ Name: "Reject", Code: "o4", Type: "", ISCHECKED: false, IsDeleted: false });
    //this.allOperations.push({ Name: "On-Hold", Code: "o5", Type: "", ISCHECKED: false, IsDeleted: false });
    //this.allOperations.push({ Name: "Discard", Code: "o6", Type: "", ISCHECKED: false, IsDeleted: false });
    //this.allOperations.push({ Name: "Withdraw", Code: "o7", Type: "", ISCHECKED: false, IsDeleted: false });
  }


  populateJson() {
    this.policy = new PolicyXML();
    this.policy.Module = this.module;
    this.policy.States = [];
    var state = new State();
    //state.Value = "1";
    //state.Text = "Draft";
    //state.IsFixed = true;

    this.policy.States.push(state);
  }

  getStates() {
    this.summaryService.getSummaryData('api/policy/getstates/' + this.screencode).subscribe((result) => {
      this.selectedStates = [];
      let TempselectStatesList=[];
      this.policy = result;
      this.policyid = result.ID;
      this.getScreens();
      let len = this.policy.States.length;
      for (var i = 0; i < len; i++) {
        if (this.policy.States[i].ISCHECKED)
        {
          let stName=this.policy.States[i].NAME;
          if(stName=="Onhold")
          {
            stName= "On-hold";
          }
          if(stName=="Discard" || stName=="discard")
          {
            stName= "Discarded";
          }
          TempselectStatesList.push(stName);
        }
      }
      this.selectedStates = [...TempselectStatesList];
      //this.addOperations();
    });
  }

  getScreens() {
    this.selectedScreens = [];
    let len = this.policy.States[0].Features.length;
    for (var i = 0; i < len; i++) {
      if (this.policy.States[0].Features[i].ISCHECKED)
        this.selectedScreens.push({Name:this.policy.States[0].Features[i].Name,RecordStatus:this.policy.States[0].Features[i].RecordStatus});
    }
    //this.summaryService.getSummaryData('api/policy/getscreens/' + this.policy.Module).subscribe((result) => {
    //  this.screens = result;
    //  this.selectedScreens = [];
    //  let len = this.screens.length;
    //  for (var i = 0; i < len; i++) {
    //    if (this.screens[i].ISCHECKED)
    //      this.selectedScreens.push(this.screens[i]);
    //  }
    //});
  }

  pickStates() {
    let StateArray=[];
    this.policy.States.forEach((state)=>{
         StateArray.push({NAME:state.NAME,SNO:state.SNO,ISCHECKED:state.ISCHECKED,Order:state.Order})
    });
    const modalRef = this.modalService.open(SelectStatesModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: '',
      states: StateArray
    
    }
    modalRef.result.then(result => {
      this.selectedStates=[];
      this.IsDirty=true;
      this.policy.States.forEach((state)=>{
        let CurrentselectedStae= result.filter((item)=>{
          return item.NAME==state.NAME;
        })[0];
        if(CurrentselectedStae!=null && CurrentselectedStae!=undefined && CurrentselectedStae.ISCHECKED==true)
        {
          state.ISCHECKED=true;
          let stName=state.NAME;
          if(stName=="Onhold")
          {
            stName= "On-hold";
          }
          if(stName.toLowerCase()=="discard")
          {
            stName= "Discarded";
          }
          this.selectedStates.push(stName);
        }
        else{
          state.ISCHECKED=false;
        }
       
      });
      this.policy.States =this.policy.States.sort((a, b) => a.SNO - b.SNO);
        
      });
    
  }

  pickScreens() {
    let modalRef = this.modalService.open(SelectScreensModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: '',
      screens: JSON.parse(JSON.stringify(this.policy.States[0].Features)),
      content: null,
      module:this.screencode
    }
    modalRef.result.then(result => {
      
      this.IsDirty=true;
      let index=0;
      this.selectedScreens=[];
      result.forEach((item,index)=>{
         item.Sno=index
      });
      let CurrentselectedScreens = result.filter((item)=>{return item.ISCHECKED==true});
      CurrentselectedScreens.forEach((item)=>{
        this.selectedScreens.push({Name:item.Name,RecordStatus:item.RecordStatus});
      });
      this.policy.States.forEach((state)=>{
        state.Features.forEach((screen)=>{
          index=index+1;
           if(CurrentselectedScreens.length>0)
           {
              let IsSelect=CurrentselectedScreens.filter((sscreen)=>{
                return sscreen.Code==screen.Code
              })[0];
              let screenData=result.filter((sscreen)=>{
                return sscreen.Code==screen.Code
              })[0];
              if(IsSelect!=undefined && IsSelect!=null)
              {
                screen.ISCHECKED = true;
              }
              else{
                  screen.ISCHECKED = false;
              }
              if(screenData!=undefined && screenData!=null)
              {
                screen.Sno=screenData.Sno; 
              }
           }
           else{
            screen.Sno=index;
            screen.ISCHECKED = false;
           }
        });
        state.Features =state.Features.sort((a, b) => a.Sno - b.Sno);
      });
    });
  }

  SavePolicyConfig() {
    if (this.selectedStates == null || this.selectedStates.length == 0 || this.selectedStates.length == undefined) {
      this.commonService.ValidationBanner("Please select Required States");
      return;
    }
    if (this.selectedScreens == null || this.selectedScreens.length == 0 || this.selectedScreens.length == undefined) {
      this.commonService.ValidationBanner("Please select Required Screens");
      return;
    }

    let IsInactiveScreens=false;
    let ScreenList=[];
    console.log(JSON.stringify("initial"+ this.policy.States))
    this.policy.States.forEach((state) => {
      console.log("satet loop "+ JSON.stringify(state))
        state.Features.forEach((currentFeature) => {
          console.log(JSON.stringify("feature loop"+currentFeature))
          if (currentFeature != undefined && currentFeature != null) {
            let IsNotConfigure=false;
            if(currentFeature.ExternalUser=="" || currentFeature.ExternalUser==null || currentFeature.ExternalUser==undefined)
            {
               IsNotConfigure=true;
            }
            if(currentFeature.InternalUser=="" || currentFeature.InternalUser==null || currentFeature.InternalUser==undefined)
            {
              IsNotConfigure=true;
            }
            if(IsNotConfigure && currentFeature.ISCHECKED==true && state.ISCHECKED==true)
            {
              IsNotConfigure=false;
              if(ScreenList.indexOf(currentFeature.Name)==-1)
              {
                ScreenList.push(currentFeature.Name);
              }
             
            }
            if(currentFeature.RecordStatus=="Inactive" && currentFeature.ISCHECKED==true)
            {
              IsInactiveScreens=true;
            }
          }
          
        });
     });
     if(ScreenList.length>0)
     {
        let message="Please update workflows for below screens </br>"
        ScreenList.forEach((item)=>{
          message=message+item+"</br>"
        })
       this.commonService.ValidationBanner(message);
       return;
     }
     if (IsInactiveScreens) {
      this.commonService.ValidationBanner("Please remove deleted/inactive screen(s) to save the details");
      return;
    }
    if (!this.rejectOp)
      this.policy.Operations[4].IsDeleted = true;
    else
      this.policy.Operations[4].IsDeleted = false;

    if (!this.onholdOp)
      this.policy.Operations[5].IsDeleted = true;
    else
      this.policy.Operations[5].IsDeleted = false;

    if (!this.discardedOp)
      this.policy.Operations[6].IsDeleted = true;
    else
      this.policy.Operations[6].IsDeleted = false;

    if (!this.withdrawOp)
      this.policy.Operations[7].IsDeleted = true;
    else
      this.policy.Operations[7].IsDeleted = false;

    // Save button Click
    this.summaryService.savePolicy(this.policy).subscribe((result) => {
      if (result.Status === 0) {
        this.IsDirty=false;
        this.commonService.SuccessBanner('Workflow Setup updated successfully');
        this.getStates();
        //this.action.next();
        //this.modalRef.hide();
      }
      else {
        this.commonService.ValidationBanner(result.Message);
      }
    });

  }

  configureScreens() {
    this.IsDirty=true;
    let modalRef = this.modalService.open(ConfigureScreensModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vvlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: '',
      content: null,
      policy: this.policy
    }
    modalRef.result.then(res => {
      this.policy = res;
    });

  }

  

  versionHistory() {
    let modalRef = this.modalService.open(VersionHistoryComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      screencode:this.screencode
    }
    modalRef.result.then(res => {
      this.getStates();
    });
  }

  canExit() {
    if (this.IsDirty) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }
}
